// extracted by mini-css-extract-plugin
module.exports = {"container":"correlation_container__nYoE0","legend_item":"correlation_legend_item__3IedB"};